 export const ENQUIRY_STUDENT_DETAILS_REQUEST =
   "ENQUIRY_STUDENT_DETAILS_REQUEST";
 export const ENQUIRY_STUDENT_DETAILS_SUCCESS =
   "ENQUIRY_STUDENT_DETAILS_SUCCESS";
 export const ENQUIRY_STUDENT_DETAILS_ERR = "ENQUIRY_STUDENT_DETAILS_ERR";

 export const ENQUIRY_STUDENT_DETAILS_WITHOUT_PAGINATION_REQUEST = "ENQUIRY_STUDENT_DETAILS_WITHOUT_PAGINATION_REQUEST"
 export const ENQUIRY_STUDENT_DETAILS_WITHOUT_PAGINATION_SUCCESS = "ENQUIRY_STUDENT_DETAILS_WITHOUT_PAGINATION_SUCCESS"

 export const ENQUIRY_STUDENT_DETAILS_FILTER_REQUEST = "ENQUIRY_STUDENT_DETAILS_FILTER_REQUEST"
 export const ENQUIRY_STUDENT_DETAILS_FILTER_SUCCESS = "ENQUIRY_STUDENT_DETAILS_FILTER_SUCCESS"

 export const ENQUIRY_STUDENT_APPLICATION_FIND_REQUEST =
   "ENQUIRY_STUDENT_APPLICATION_FIND_REQUEST";
 export const ENQUIRY_STUDENT_APPLICATION_FIND_SUCCESS =
   "ENQUIRY_STUDENT_APPLICATION_FIND_SUCCESS";
 export const ENQUIRY_STUDENT_APPLICATION_FIND_ERR = "ENQUIRY_STUDENT_APPLICATION_FIND_ERR";

